export default function circledTransform(input) {
  return input
    .replace(/a/gi, "ⓐ")
    .replace(/b/gi, "ⓑ")
    .replace(/c/gi, "ⓒ")
    .replace(/d/gi, "ⓓ")
    .replace(/e/gi, "ⓔ")
    .replace(/f/gi, "ⓕ")
    .replace(/g/gi, "ⓖ")
    .replace(/h/gi, "ⓗ")
    .replace(/i/gi, "ⓘ")
    .replace(/j/gi, "ⓙ")
    .replace(/k/gi, "ⓚ")
    .replace(/l/gi, "ⓛ")
    .replace(/m/gi, "ⓜ")
    .replace(/n/gi, "ⓝ")
    .replace(/o/gi, "ⓞ")
    .replace(/p/gi, "ⓟ")
    .replace(/q/gi, "ⓠ")
    .replace(/r/gi, "ⓡ")
    .replace(/s/gi, "ⓢ")
    .replace(/t/gi, "ⓣ")
    .replace(/u/gi, "ⓤ")
    .replace(/v/gi, "ⓥ")
    .replace(/w/gi, "ⓦ")
    .replace(/x/gi, "ⓧ")
    .replace(/y/gi, "ⓨ")
    .replace(/z/gi, "ⓩ")
    .replace(/0/gi, "⓪")
    .replace(/1/gi, "➀")
    .replace(/2/gi, "➁")
    .replace(/3/gi, "➂")
    .replace(/4/gi, "➃")
    .replace(/5/gi, "➄")
    .replace(/6/gi, "➅")
    .replace(/7/gi, "➆")
    .replace(/8/gi, "➇")
    .replace(/9/gi, "➈")
    .replace(/á/gi, "ⓐ")
    .replace(/â/gi, "ⓐ")
    .replace(/ã/gi, "ⓐ")
    .replace(/é/gi, "ⓔ")
    .replace(/ê/gi, "ⓔ")
    .replace(/í/gi, "ⓘ")
    .replace(/ó/gi, "ⓞ")
    .replace(/ô/gi, "ⓞ")
    .replace(/õ/gi, "ⓞ")
    .replace(/ú/gi, "ⓤ")
    .replace(/Á/gi, "ⓐ")
    .replace(/Â/gi, "ⓐ")
    .replace(/Ã/gi, "ⓐ")
    .replace(/É/gi, "ⓔ")
    .replace(/Ê/gi, "ⓔ")
    .replace(/Í/gi, "ⓘ")
    .replace(/Ó/gi, "ⓞ")
    .replace(/Ô/gi, "ⓞ")
    .replace(/Õ/gi, "ⓞ")
    .replace(/Ú/gi, "ⓤ")
    .replace(/ç/gi, "ⓒ")
    .replace(/Ç/gi, "ⓒ")
    .replace(/ /gi, "ㅤ");
}
